<sc-no-data-container [hasData]="this.dataSource.filteredData.length >  0">

  <table class="mat-table-selection" mat-table [dataSource]="dataSource" matSort matSortActive="{{sortColumn}}"
    [matSortDirection]="sortDirection">

    <ng-container matColumnDef="driver">
      <th mat-header-cell mat-sort-header *matHeaderCellDef>{{'driver'|
        translate:['tmc.visit.overview.trucks.table.column.driver', translationService.language]}}</th>
      <td mat-cell class="text-selection" *matCellDef="let visit"> {{visit.driver}} </td>
    </ng-container>

    <ng-container matColumnDef="coDriver">
      <th mat-header-cell mat-sort-header *matHeaderCellDef>{{'coDriver'|
        translate:['tmc.visit.overview.trucks.table.column.coDriver', translationService.language]}}</th>
      <td mat-cell class="text-selection" *matCellDef="let visit"> {{visit.coDriver}} </td>
    </ng-container>

    <ng-container matColumnDef="carrier">
      <th mat-header-cell mat-sort-header *matHeaderCellDef>{{'carrier'|
        translate:['tmc.visit.overview.trucks.table.column.carrier', translationService.language]}}</th>
      <td mat-cell class="text-selection" *matCellDef="let visit"> {{visit.carrier}} </td>
    </ng-container>

    <ng-container matColumnDef="supplier">
      <th mat-header-cell mat-sort-header *matHeaderCellDef>{{'supplier'|
        translate:['tmc.visit.overview.trucks.table.column.supplier', translationService.language]}}</th>
      <td mat-cell class="text-selection" *matCellDef="let visit"> {{visit.supplier}} </td>
    </ng-container>

    <ng-container matColumnDef="numberPlate">
      <th mat-header-cell mat-sort-header *matHeaderCellDef>{{'numberPlate'|
        translate:['tmc.visit.overview.trucks.table.column.numberPlate', translationService.language]}}</th>
      <td mat-cell class="text-selection" *matCellDef="let visit"> {{visit.numberPlate}} </td>
    </ng-container>

    <ng-container matColumnDef="registration">
      <th mat-header-cell mat-sort-header *matHeaderCellDef>{{'registration'|
        translate:['tmc.visit.overview.trucks.table.column.registration', translationService.language]}}</th>
      <td mat-cell class="text-selection" *matCellDef="let visit"> {{visit.registration}} </td>
    </ng-container>

    <ng-container matColumnDef="filler">
      <th mat-header-cell *matHeaderCellDef style="width: 100%;"> &nbsp; </th>
      <td mat-cell *matCellDef="let transport"> &nbsp;</td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="columnsToDisplay; sticky: true"></tr>

    <tr mat-row *matRowDef="let visit; columns: columnsToDisplay" [ngClass]="getRowStyles(visit)"
      (click)="toggleSelection(visit)"></tr>


  </table>

</sc-no-data-container>
